import {ChangeEvent, useState, useContext} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {toast} from 'react-toastify'
import AuthContainer from '../features/authentication/components/AuthContainer'
import Layout from '../layout/Layout'
import Input from '../component/Input'
import Button from '../component/Button'
import axios, { AxiosError } from 'axios';
import { UserContext } from '../context/userContext';
import { isEmailValid, isPasswordValid } from '../util/middleware';
import { RouteContext } from '../context/routeContext';

function LoginPage() {
  const {setLocalUser,setUser} = useContext(UserContext);
  const {setActivePage} = useContext(RouteContext);

  type authUser = {email:string,password:string}
  const navigate = useNavigate();
  // ERRORS
  const [emailError, setEmailError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");

  const [userInput,setUserInput] = useState<authUser>({'email':'','password':''})
  const {email,password} = userInput;

  const validateEmail = (value:string) => {
    let emailRes:(boolean|string)[] = isEmailValid(value);
    // console.log(emailRes)
    let isValidEmail:(boolean|string) =emailRes[0]===true ? emailRes[1] : "" 
    setEmailError(isValidEmail as string);
  };

  const validatePassword = (value:string) => {
    let paswdRes:(boolean|string)[]= isPasswordValid(value);
    let isValidPassword:(boolean|string)  = paswdRes[0]===true ? paswdRes[1] : "";
    setPasswordError(isValidPassword as string);
  };

  const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
    // console.log('===============changing=============');
      e.preventDefault();
      const { value, id} = e.target;

      setUserInput((prev: authUser)=>({...prev,[id]:value})) 
        if(id==='email'){
          validateEmail(value);
        }else{
          validatePassword(value);
        }   
      }

      const handleLogin = async() =>{
        // e.preventDefault()
        // console.log('==============Logging In===========');
            try {

                const newData:authUser = {email,password}
                // Get Access to Signer
                // Make Function Call
                const response =await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/loginUser`,newData);
                // console.log('response',response)
                if(response.status ===200){
                setLocalUser(response.data.data)
                setUser(response.data.data) 
                toast.success("Login Successful !", {
                    position: toast.POSITION.TOP_CENTER
                  });
                reset();
                setActivePage('/donation')
                navigate('/donation');
               
                }
                else{
                    toast.error("Couldn't Login !", {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                
            } catch (error) {
              const axiosError = error as any;
              const displayMessage = axiosError.response?.data.message??axiosError.message;
              // console.log('My Error', axiosError.response?.data.message??axiosError.message);

                toast.error(`${displayMessage}`, {
                    position: toast.POSITION.TOP_LEFT
                  });                
            }       
}
const reset = ()=>{
  setUserInput({'email':'','password':''})
}
  return (
    <div className='h-screen w-full'>
      <Layout>
      <AuthContainer>
      <h1 className='font-bold text-center' >Admin Portal</h1>        
      <p className='text-left mt-1'>Email:</p>
      {emailError && <p className='text-red-500' >{emailError}</p>}
      <Input type={'text'} name={'email'} id={'email'} placeholder={'Enter email'} value={email} onChange={handleChange} required={true}/>
      <p className='mt-1' >Password:</p>
      {passwordError && <p className='text-red-500'>{passwordError}</p>}
      <Input type={'password'} name={'password'} id={'password'} placeholder={'Enter password'} value={password} onChange={handleChange} required={true}/>
      <p className='text-right mt-1 mb-2'><Link to={'/forgotpassword'} >Forgot Password?</Link> </p>

      <Button label={'Login'} onClick={()=>!emailError&&!passwordError?handleLogin():null}></Button>

      </AuthContainer>
      </Layout>
    </div>
  )
}

export default LoginPage